import React, { useState } from "react";
import {
  SunIcon,
  RupeeIcon,
  MoonIcon,
  EditIcon,
  CopyIcon,
  SettingsIcon,
  UserIcons,
  WalletIcon,
  ExposureIcon,
  RefreshIcon,
  CloseIcon,
  TickIcon,
} from "../../components/HeaderSidebarIcons";
import { useNavigate } from "react-router-dom";
import { logLogout } from "../../utils/activityLogger";
import { useBalance } from "../../contexts/BalanceContext";

import {
  Drawer,
  DrawerContent,
  DrawerBody,
  Button,
  Input,
  useDisclosure,
  Switch,
} from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@heroui/react";

const AccountSidebar = ({ isOpen, onClose }) => {
  const { onOpen, onOpenChange } = useDisclosure();
  const {
    isOpen: isSidebarOpen,
    onOpen: openSidebar,
    onOpenChange: onSidebarChange,
  } = useDisclosure();

  const {
    isOpen: isContentModalOpen,
    onOpen: openContentModal,
    onOpenChange: onContentModalChange,
  } = useDisclosure();

  const {
    isOpen: isBonusModalOpen,
    onOpen: openBonusModal,
    onOpenChange: onBonusModalChange,
  } = useDisclosure();

  const [isSettingsOpen, setIsSettingsOpen] = useState(true);
  const [inputValue, setInputValue] = useState(1000);
  const [inputValue1, setInputValue1] = useState(1000);
  const [inputValue2, setInputValue2] = useState(1000);
  const navigate = useNavigate();
  // const { balance, exposure, resetWallet } = useBalance();

  const flushItem = async () => {
    await logLogout();
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <Drawer isOpen={isOpen} onClose={onClose} placement="right">
        <DrawerContent>
          {(onClose) => (
            <>
              <DrawerBody>
                <div className="border-m_gray border rounded-md py-2 mt-8">
                  {/* Top bar */}
                  <div className="flex items-center justify-between border-b w-full py-2">
                   <div className="flex items-center gap-1 px-4 py-3">
                      <span className="text-matka_yellow">
                        <UserIcons />
                      </span>
                      <span className="font-semibold text-matka_black">
                        {localStorage.getItem("name") || "user"}
                      </span>
                    </div>
                    {/* <div className="p-1 bg-m_blue mr-1">
                      <CopyIcon />
                    </div> */}
                  </div>

                  {/* Settings row */}
                  {/* <div className="flex items-center justify-between border-b w-full">
                    <div className="flex items-center gap-1 px-4 py-2">
                      <span>
                        <SettingsIcon />
                      </span>
                      <span className="font-semibold text-m_blue">
                        Settings
                      </span>
                    </div>
                    <div className="flex items-center px-4 py-2 gap-2">
                      <Switch
                        isSelected={isSettingsOpen}
                        onChange={() => setIsSettingsOpen(!isSettingsOpen)}
                        color="primary"
                        endContent={<CloseIcon />}
                        size="md"
                        startContent={<TickIcon />}
                      />
                      <span className="text-sm font-medium text-gray-700">
                        One Click Bet
                      </span>
                    </div>
                  </div> */}

                  {/* Accordion Content */}
                  {/* <div
                    className={`transition-all duration-300 ease-in-out overflow-hidden border-b  ${
                      isSettingsOpen ? "max-h-70 py-2" : "max-h-0 py-0"
                    }`}
                  > */}
                    {/* Put your expanded settings content here */}
                    {/* <div className="px-4  flex flex-col items-center text-center">
                      <div>
                        <Input
                          type="number"
                          className=" rounded-sm px-2 py-1 text-center"
                          radius="none"
                          value={inputValue}
                          variant="bordered"
                          onChange={(e) => setInputValue(e.target.value)}
                        />
                      </div>
                      <div className="text-center">
                        <Input
                          type="number"
                          className="rounded-sm px-2 py-1"
                          radius="none"
                          value={inputValue1}
                          variant="bordered"
                          onChange={(e) => setInputValue1(e.target.value)}
                        />
                      </div>
                      <div className="text-center">
                        <Input
                          type="number"
                          className=" rounded-sm px-2 py-1 "
                          radius="none"
                          value={inputValue2}
                          variant="bordered"
                          onChange={(e) => setInputValue2(e.target.value)}
                        />
                      </div>
                      <div className="text-center">
                        <Input
                          type="number"
                          className=" rounded-sm px-2 py-1 "
                          radius="none"
                          value={inputValue2}
                          variant="bordered"
                          onChange={(e) => setInputValue2(e.target.value)}
                        />
                      </div>
                      <div className="flex gap-4">
                        <Button
                          className="bg-white text-m_blue border border-m_blue rounded-none px-4 py-1 mt-2"
                          radius="none"
                          onClick={() => setIsSettingsOpen(false)}
                        >
                          Close
                        </Button>
                        <Button
                          className="bg-m_blue text-white rounded-none px-4 py-1 mt-2"
                          radius="none"
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </div> */}

                  {/* Display Name */}
                  {/* <div className="flex items-center justify-between border-b w-full">
                    <div className="flex items-center gap-1 px-4 py-3">
                      <span>
                        <UserIcons />
                      </span>
                      <span className="font-semibold text-m_blue">
                        Display Name
                      </span>
                    </div>
                    <div className="flex items-center">
                      <span className="text-xs">DEMO188</span>
                      <Button
                        onClick={openContentModal}
                        variant="light"
                        size="sm"
                        isIconOnly
                      >
                        <EditIcon />
                      </Button>
                    </div>
                  </div> */}

                  {/* Wallet */}
                  <div className="flex items-center justify-between border-b w-full">
                    <div className="flex items-center gap-1 px-4 py-2">
                      <span className="text-matka_yellow">
                        <WalletIcon />
                      </span>
                      <span className="font-semibold text-matka_black">
                        Wallet Balance
                      </span>
                    </div>
                    <div className="flex px-1 ">
                      <span className="text-matka_yellow"><RupeeIcon /></span>
                      {/* <span>{balance !== null ? balance : "-"}</span> */}
                    </div>
                  </div>

                  {/* Exposure */}
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center gap-1 px-4 py-2">
                      <span className="text-matka_yellow">
                        <ExposureIcon />
                      </span>
                      <span className="font-semibold text-matka_black">
                        Exposure
                      </span>
                    </div>
                    <div className="px-2">
                      {/* <span className="text-sm">{exposure !== null ? exposure : "-"}</span> */}
                    </div>
                  </div>

                  {/* Locked Bonus */}
                  {/* <div className="flex justify-center">
                    <div className="flex flex-col items-center ml-4 mr-4 mt-3 bg-m_blue text-white rounded-sm px-4 py-1">
                      <span>Locked Bonus</span>
                      <div className="flex">
                        <span className="font-semibold">9.00 </span>
                        <span className="justify-center">
                          <Button
                            onClick={openBonusModal}
                            variant="light"
                            size="sm"
                            isIconOnly
                          >
                            <RefreshIcon />
                          </Button>
                        </span>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="flex justify-center bg-matka_black py-2 text-matka_yellow">
                  <button onClick={() => flushItem()}>Log Out</button>
                </div>
              </DrawerBody>
            </>
          )}
        </DrawerContent>
      </Drawer>

      <Modal isOpen={isContentModalOpen} onOpenChange={onContentModalChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>Display Name</ModalHeader>
              <ModalBody>
                <Input
                  placeholder="Enter your Display Name"
                  type="text"
                  value="demo188"
                  variant="bordered"
                  required
                />
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onPress={onClose}>
                  Save
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>

      <Modal isOpen={isBonusModalOpen} onOpenChange={onBonusModalChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>Display Name</ModalHeader>
              <ModalBody>
                <Input
                  placeholder="Enter your Display Name"
                  type="text"
                  value="demo188"
                  variant="bordered"
                  required
                />
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onPress={onClose}>
                  Save
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};
export default AccountSidebar;
